import { trackMixpanel } from '../../mixpanel/base';
import { CardInteractionMixpanelData, CardInteractionMixpanelProps } from './types';

const COMPONENT = 'Delivery Card';
const MIXPANEL_EVENT_NAME = 'Interaction';

const toMixpanelData = ({
    positionInFeed,
    hostingScreen,
    deliveryId,
    gigId,
    sellerId,
    itemType,
    subCategoryId,
    width,
    height,
    action,
    platform,
    component,
    pageName,
    price,
    subCategoryName,
    nestedSubCategoryName,
    nestedSubCategoryId,
}: CardInteractionMixpanelProps): CardInteractionMixpanelData => ({
    'Position in feed': positionInFeed,
    'Hosting screen': hostingScreen,
    'Delivery Id': deliveryId,
    'Gig Id': gigId,
    'Seller Id': sellerId,
    'Item type': itemType,
    'Subcategory Id': subCategoryId,
    'Nested Sub Category Id': nestedSubCategoryId,
    Width: width,
    Height: height,
    Action: action,
    Platform: platform,
    Component: component,
    'Page Name': pageName,
    'Min Package Price': price,
    'Subcategory Name': subCategoryName,
    'Nested Subcategory Name': nestedSubCategoryName,
});

export const trackMixpanelCardInteraction = (props: CardInteractionMixpanelProps) => {
    trackMixpanel(COMPONENT, MIXPANEL_EVENT_NAME, { ...toMixpanelData(props), ...(props.enrichment ?? {}) });
};
